module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/single-2e2022b75270705f9f3fb40209409c9c.webp";